<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>

<div class="product-locations-dialog">
    <div class="toolbar mb-3 flex justify-content-between align-items-center">
        <div class="flex gap-2">
            @if (isEditMode) {
            <p-button label="Update" icon="pi pi-save" size="small" severity="info" (click)="save()"
                [loading]="saving"></p-button>
            } @else {
            <p-button label="Save" icon="pi pi-save" size="small" (click)="save()" [loading]="saving"></p-button>
            }
            <p-button label="Delete" icon="pi pi-trash" size="small" severity="danger" (click)="deleteSelected()"
                [disabled]="!hasSelectedRows()"></p-button>
        </div>
        <label class="label-required font-bold">Required Fields</label>
    </div>

    <div class="grid header-fields mb-3">
        <div class="col-12 md:col-4">
            <div class="field text-left">
                <label class="label-required font-bold">Warehouse</label>
                <p-dropdown [options]="warehouseList" [(ngModel)]="selectedWarehouseId" optionLabel="warehouseName"
                    optionValue="warehouseId" placeholder="Select Warehouse" [filter]="true"
                    filterBy="warehouseCode,warehouseName" styleClass="w-full" appendTo="body"
                    (onChange)="onWarehouseChange()">
                    <ng-template let-item pTemplate="item">
                        <span>{{ item.warehouseCode }} - {{ item.warehouseName }}</span>
                    </ng-template>
                </p-dropdown>
            </div>
        </div>

        <div class="col-12 md:col-4">
            <div class="field text-left">
                <label class="font-bold">Quantity On Hand</label>
                <input pInputText class="w-full" [value]="quantityOnHand" readonly />
            </div>
        </div>

        <div class="col-12 md:col-4">
            <div class="field text-left">
                <label class="font-bold">Qty Pick</label>
                <input pInputText class="w-full" [value]="qtyPicked" readonly />
            </div>
        </div>
    </div>

    <p-table [value]="rows" dataKey="tempId" [(selection)]="selectedRows"
        styleClass="p-datatable-sm product-location-table" responsiveLayout="scroll"
        [paginator]="true" [rows]="rowsPerPage" [first]="first"
        [alwaysShowPaginator]="true"
        [rowsPerPageOptions]="[5, 10, 15, 20]"
        paginatorDropdownAppendTo="body" [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        (onPage)="onPageChange($event)">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 3.5rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th style="min-width: 100px;">UOM</th>
                <th style="min-width: 300px;" class="label-required">Location</th>
                <th style="min-width: 300px;">Location Name</th>
                <th style="min-width: 100px;">Primary?</th>
                <th style="min-width: 140px;">Current Qty</th>
                <th style="min-width: 140px;">Qty Picked</th>
                <th style="min-width: 140px;">New Qty</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-i="rowIndex">
            <tr>
                <td>
                    <p-tableCheckbox [value]="row"></p-tableCheckbox>
                </td>
                <td>
                    <input pInputText class="w-full" [(ngModel)]="row.uom" readonly />
                </td>
                <td>
                    <p-dropdown [options]="locationOptions" [(ngModel)]="row.wmsLocationId" optionLabel="locationCode"
                        optionValue="wmsLocationId" placeholder="Select Location" [filter]="true"
                        filterBy="locationCode,locationName" [showClear]="true" appendTo="body"
                        styleClass="w-full location-dropdown" (onChange)="onLocationChange(row)">
                        <ng-template let-item pTemplate="item">
                            <span>{{ item.locationCode }} - {{ item.locationName }}</span>
                        </ng-template>
                    </p-dropdown>
                </td>
                <td>
                    <input pInputText class="w-full" [(ngModel)]="row.locationDescription" readonly />
                </td>
                <td class="text-center">
                    <p-checkbox [(ngModel)]="row.isPrimary" [binary]="true"
                        (onChange)="onPrimaryChange(row)"></p-checkbox>
                </td>
                <td>
                    <input pInputText type="number" class="w-full text-right" [(ngModel)]="row.currentQty" readonly />
                </td>
                <td>
                    <input pInputText type="number" class="w-full text-right" [(ngModel)]="row.pickQty" min="0"
                        [readonly]="isEditMode" />
                </td>
                <td>
                    <input pInputText type="number" class="w-full text-right" [(ngModel)]="row.newQty" min="0" />
                </td>
            </tr>
        </ng-template>
    </p-table>

    <div class="mt-3">
        <a class="new-row-link" (click)="addRow()">
            <i class="pi pi-plus"></i> New Row
        </a>
    </div>
</div>